import { toast } from './message'

function timeToMinutes(t) {
  if (!t) return 0
  const parts = t.split(':')
  return parseInt(parts[0], 10) * 60 + parseInt(parts[1] || '0', 10)
}

function minutesToTime(m) {
  const hh = String(Math.floor(m / 60)).padStart(2, '0')
  const mm = String(m % 60).padStart(2, '0')
  return `${hh}:${mm}`
}

function parseDateInput(value) {
  // supports yyyy-mm-dd (native date) or dd/mm/yyyy
  if (!value) return null
  if (value.indexOf('-') > -1) return new Date(value)
  if (value.indexOf('/') > -1) {
    const parts = value.split('/')
    if (parts.length === 3) return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`)
  }
  const d = new Date(value)
  return isNaN(d.getTime()) ? null : d
}

function parseDataLocal(value) {
  if (!value) return null
  let y, m, d
  if (value.indexOf('/') > -1) {
    const parts = value.split('/') // dd/mm/yyyy
    if (parts.length !== 3) return null
    d = Number(parts[0])
    m = Number(parts[1])
    y = Number(parts[2])
  } else {
    const parts = value.split('-') // yyyy-mm-dd
    if (parts.length !== 3) return null
    y = Number(parts[0])
    m = Number(parts[1])
    d = Number(parts[2])
  }
  if (!y || !m || !d) return null
  return new Date(y, m - 1, d)
}

function createTimeOverlay(input, times) {
  // cria backdrop/modal (central) mobile-first
  let backdrop = document.getElementById('agendamento-hora-backdrop')
  if (!backdrop) {
    backdrop = document.createElement('div')
    backdrop.id = 'agendamento-hora-backdrop'
    // backdrop styles
    Object.assign(backdrop.style, {
      position: 'fixed',
      inset: '0',
      background: 'rgba(0,0,0,0.45)',
      display: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2147483647,
      padding: '16px',
      WebkitOverflowScrolling: 'touch',
    })

    const dialog = document.createElement('div')
    dialog.id = 'agendamento-hora-dialog'
    Object.assign(dialog.style, {
      width: '230px',
      maxWidth: '520px',
      maxHeight: '80vh',
      background: '#fff',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 12px 30px rgba(0,0,0,0.25)',
      display: 'flex',
      flexDirection: 'column',
    })

    const header = document.createElement('div')
    Object.assign(header.style, {
      padding: '12px 16px',
      borderBottom: '1px solid #eee',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    })
    const title = document.createElement('strong')
    title.textContent = 'Selecione um horário'
    title.style.fontSize = '1.4rem'
    const closeBtn = document.createElement('button')
    closeBtn.type = 'button'
    closeBtn.setAttribute('aria-label', 'Fechar')
    Object.assign(closeBtn.style, {
      border: 'none',
      background: 'transparent',
      fontSize: '1.25rem',
      color: '#444',
    })
    closeBtn.innerHTML = '✕'
    header.appendChild(title)
    header.appendChild(closeBtn)

    const list = document.createElement('div')
    list.id = 'agendamento-hora-list'
    Object.assign(list.style, {
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      padding: '8px',
    })

    dialog.appendChild(header)
    dialog.appendChild(list)
    backdrop.appendChild(dialog)
    document.body.appendChild(backdrop)

    // close handlers
    backdrop.addEventListener('click', (ev) => {
      if (ev.target === backdrop) hideModal()
    })
    closeBtn.addEventListener('click', hideModal)
  }

  const list = backdrop.querySelector('#agendamento-hora-list')
  list.innerHTML = ''

  times.forEach((t) => {
    const item = document.createElement('button')
    item.type = 'button'
    item.className = 'time-option'
    Object.assign(item.style, {
      padding: '12px 14px',
      textAlign: 'left',
      border: 'none',
      borderRadius: '8px',
      background: '#fafafa',
      fontSize: '1.2rem',
    })
    item.textContent = t
    item.addEventListener('click', () => {
      input.value = t
      hideModal()
      input.dispatchEvent(new Event('input', { bubbles: true }))
    })
    list.appendChild(item)
  })

  function showModal() {
    backdrop.style.display = 'flex'
    // prevent body scroll behind
    document.documentElement.style.overflow = 'hidden'
    // focus first element for accessibility
    const first = list.querySelector('button')
    first && first.focus()
  }

  function hideModal() {
    backdrop.style.display = 'none'
    document.documentElement.style.overflow = ''
  }

  return { showModal, hideModal }
}

export function initAgendamento(estabelecimento, selectors = {}) {
  const dateSelector = selectors.date || '#agendamento-data'
  const timeSelector = selectors.time || '#agendamento-hora'
  const dateInput = document.querySelector(dateSelector)
  const timeInput = document.querySelector(timeSelector)

  if (!dateInput || !timeInput) return

  // set min date based on intervaloDias (número de dias a somar na data mínima).
  // Fallback para `intervalo` quando `intervaloDias` não vier do backend.
  const agendamento = (estabelecimento && estabelecimento.agendamento) || {}
  const intervaloDias =
    (agendamento.intervaloDias != null ? agendamento.intervaloDias : agendamento.intervalo) || 0
  const minDate = new Date()
  minDate.setDate(minDate.getDate() + Number(intervaloDias))
  // format yyyy-mm-dd
  const yyyy = minDate.getFullYear()
  const mm = String(minDate.getMonth() + 1).padStart(2, '0')
  const dd = String(minDate.getDate()).padStart(2, '0')
  dateInput.setAttribute('min', `${yyyy}-${mm}-${dd}`)

  // Helper to generate slots for given intervals
  function generateSlots(intervalos, step = 15) {
    const slots = []
    intervalos.forEach((itv) => {
      const start = timeToMinutes(itv.StartTime || '00:00')
      const end = timeToMinutes(itv.EndTime || '00:00')
      for (let m = start; m + step <= end; m += step) {
        slots.push(minutesToTime(m))
      }
    })
    return slots
  }

  // When date changes, validate day open and populate times
  let overlayController = null
  let availableSlots = []
  let overlayOpenedAt = 0
  // safety flag to ignore the opening click on document
  let ignoreDocumentClick = false

  function patchOverlayController(controller) {
    if (!controller || controller.__patched) return controller
    const originalShow = controller.showModal
    const originalHide = controller.hideModal

    controller.showModal = () => {
      overlayOpenedAt = Date.now()
      originalShow && originalShow()
    }

    controller.hideModal = () => {
      overlayOpenedAt = 0
      originalHide && originalHide()
    }

    controller.__patched = true
    return controller
  }

  const ensureFocusListener = () => {
    if (timeInput.dataset.agendamentoFocusBound) return
    timeInput.dataset.agendamentoFocusBound = 'true'
    timeInput.addEventListener('focus', () => {
      if (!availableSlots.length || !overlayController) return
      overlayController.showModal()
    })
  }

  const ensureManualValidation = () => {
    if (timeInput.dataset.agendamentoValidationBound) return
    timeInput.dataset.agendamentoValidationBound = 'true'
    timeInput.addEventListener('input', () => {
      const value = timeInput.value
      if (!value || value.length < 5 || !availableSlots.length) return
      const parts = value.split(':')
      if (parts.length < 2) return
      const normalized = `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`
      if (!availableSlots.includes(normalized)) {
        toast('Hora selecionada não está disponível')
      }
    })
  }

  // prevent clicks on the time input from propagating to the document
  timeInput.addEventListener('click', (ev) => {
    ev.stopPropagation()
    if (!timeInput.hasAttribute('disabled') && availableSlots.length && overlayController) {
      overlayController.showModal()
    }
    // ignore the next document click for the same interaction
    ignoreDocumentClick = true
    setTimeout(() => (ignoreDocumentClick = false), 500)
  })
  timeInput.addEventListener('pointerdown', (ev) => {
    // pointerdown covers mouse/touch/pen before click
    ev.stopPropagation()
    ignoreDocumentClick = true
    setTimeout(() => (ignoreDocumentClick = false), 500)
  })
  timeInput.addEventListener('touchstart', (ev) => {
    ev.stopPropagation()
    ignoreDocumentClick = true
    setTimeout(() => (ignoreDocumentClick = false), 500)
  })

  ensureFocusListener()
  ensureManualValidation()

  dateInput.addEventListener('input', () => {
    const parsed = parseDateInput(dateInput.value)
    if (!parsed) return
    const todayIndex = parsed.getDay()

    const dias = (estabelecimento && estabelecimento.diasDelivery) || []
    const selectedDay = dias.find((d) => Number(d.DiaDaSemana) == Number(todayIndex + 1))

    if (!selectedDay || selectedDay.Aberto === false) {
      availableSlots = []
      overlayController && overlayController.hideModal && overlayController.hideModal()
      timeInput.setAttribute('disabled', '')
      timeInput.value = ''
      toast('Data selecionada está fechada para entrega')
      return
    }

    const intervalos = selectedDay.Intervalos || []
    if (!intervalos || intervalos.length === 0) {
      availableSlots = []
      overlayController && overlayController.hideModal && overlayController.hideModal()
      timeInput.setAttribute('disabled', '')
      toast('Nenhum horário disponível neste dia')
      return
    }

    timeInput.removeAttribute('disabled')

    // generate slots
    // Assumption: step 15 minutes (padrão). Podemos ajustar se o backend fornecer passo.
    availableSlots = generateSlots(intervalos, 15)

    const agora = new Date()
    const dataLocal = parseDataLocal(dateInput.value)
    const ehHoje =
      dataLocal &&
      dataLocal.getFullYear() === agora.getFullYear() &&
      dataLocal.getMonth() === agora.getMonth() &&
      dataLocal.getDate() === agora.getDate()

    if (ehHoje) {
      const minMinutos =
        agora.getHours() * 60 + agora.getMinutes() + (estabelecimento.agendamento.intervaloMinutos || 0)
      availableSlots = availableSlots.filter((t) => timeToMinutes(t) >= minMinutos)

      if (availableSlots.length === 0) {
        overlayController && overlayController.hideModal && overlayController.hideModal()
        timeInput.setAttribute('disabled', '')
        timeInput.value = ''
        toast('Não há mais horários disponíveis para hoje')
        return
      }
    }

    // attach overlay for mobile-friendly selection
    if (overlayController) {
      overlayController.hideModal && overlayController.hideModal()
    }
    overlayController = patchOverlayController(createTimeOverlay(timeInput, availableSlots))
  })

  // close overlay on outside click
  // close backdrop if clicking outside (handles non-modal interactions)
  document.addEventListener('click', (ev) => {
    if (ignoreDocumentClick) return
    const now = Date.now()
    if (overlayOpenedAt && now - overlayOpenedAt < 500) return
    const backdrop = document.getElementById('agendamento-hora-backdrop')
    if (!backdrop || backdrop.style.display === 'none') return
    if (ev.target === timeInput) return
    if (backdrop.contains(ev.target) && ev.target.closest && ev.target.closest('#agendamento-hora-dialog')) return
    overlayController && overlayController.hideModal && overlayController.hideModal()
  })
}

export default { initAgendamento }
